export const SOME_MUTATION = 'SOME_MUTATION'
export const SET_SCHOOLS = 'SET_SCHOOLS'
export const SET_OFTEN_TIMES = 'SET_OFTEN_TIMES'
export const SET_SCHOOL_ID = 'SET_SCHOOL_ID'
export const SET_DEV_MODE = 'SET_DEV_MODE'
export const SET_TEACHERS = 'SET_TEACHERS'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_EXPIRES_AT = 'SET_EXPIRES_AT'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const SET_IsSystemManager = 'SET_IsSystemManager'
export const SET_ROUTES = 'SET_ROUTES'
export const SET_IN_LOGIN_PAGE = 'SET_IN_LOGIN_PAGE'
export const SET_MemberModuleNames = 'SET_MemberModuleNames'
export const SET_SIDE_BAR_ITEMS = 'SET_SIDE_BAR_ITEMS'
export const SetSchoolModuleNames = 'SetSchoolModuleNames'
export const SET_salaryTypesOfSchools = 'SET_salaryTypesOfSchools'
export const SetLessonAppointByClazz = 'SetLessonAppointByClazz'
export const ResetSchoolConfig = 'ResetSchoolConfig'
export const SetSchoolConfigs = 'SetSchoolConfigs'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js